// Keyboard shortcuts for screening actions

document.addEventListener('keydown', function(event) {
  if(!document.body.classList.contains('action-screening')) return;

  const element = document.querySelector(`button[data-hotkey="${event.key}"]`);

  element?.click();
});
